import { HcLazyload } from '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component'

document.addEventListener('DOMContentLoaded', () => {
    for (const element of document.querySelectorAll('[data-element="block-customer-cts-list"]')) {
        const toggle = element.querySelector('[data-trigger="cts-filters-toggle"]')
        const filter = element.querySelector('[data-trigger="cts-filters-list"]')
        toggle.addEventListener('click', () => {
            toggle.classList.toggle('opened')
            filter.classList.toggle('open')
        })
    }

    document.addEventListener('facetwp-loaded', () => {
        HcLazyload.update()
    })
})
